export enum AccountTabKey {
    Profile = 'profile',
    Notifications = 'notifications',
    Subscribe = 'subscribe',
    ChatBot = 'chatBot',
}
